var map = {
	"./2017.txt": 6308,
	"./2018.txt": 2546,
	"./2019.txt": 9659,
	"./2020.txt": 9467,
	"./2021.txt": 665,
	"./2022.txt": 975,
	"./2023.txt": 4145,
	"./2024.txt": 2381,
	"./2025.txt": 8313,
	"./2026.txt": 7864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6266;